import { Component, Pipe, PipeTransform, ViewChild } from '@angular/core';
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';

import {SlideshowService} from '../slideshow.service';
import {ImagesService} from '../../shared/images.service';

@Pipe({name: 'imageSearch'})
export class SearchImagesPipe implements PipeTransform {
    transform(list, search): string {
        if( !list || !search ) {
            return list;
        }
        return list.filter(item => {
            for(var i in item) {
                const value = item[i] + '';
                if( i !== 'width' && i !== 'height' && i !== 'id' && i !== 'sizes' && value.indexOf(search) !== -1 ) {
                    return true;
                }
            }
            return false;
        });
    }
}

@Component({
    selector: 'images-component',
    templateUrl: 'images.component.html'
})
export class ImagesComponent {
    downloads = [];
    zip = new JSZip();
    selected;
    searchText = '';
    gettySearch = false;

    constructor(
        private imagesService: ImagesService,
        private slideshow: SlideshowService
    ) {}
    drop(e) {
        if( this.slideshow.locked ) {
            return;
        }
        this.imagesService.handleDropFiles(e.event.dataTransfer.files, this.slideshow.assignment, false);
    }
    removeFromDownloads(img) {
        let i = this.downloads.length;
        while(i--) {
            if( this.downloads[i].id == img.id ) {
                this.downloads.splice(i, 1);
            }
        }
    }
    addToDownloads(img) {
        img = JSON.parse(JSON.stringify(img));
        this.downloads.push(img);
    }
    toggleSelected(e, img) {
        if( e.target.classList.contains('mat-icon') ) {
            if( e.target.classList.contains('remove-download') ) {
               this.removeFromDownloads(img); 
            }            
            return;
        }

        const inDownloads = this.inDownloads(img);
        const selected = this.selected;
        if( selected && !selected.ctrlclick && !e.ctrlKey ) {
            this.removeFromDownloads(selected);
        } 
        
        if( e.ctrlKey ) {
            if( inDownloads ) {
                img.ctrlclick = false;
                this.removeFromDownloads(img);
            } else {
                img.ctrlclick = true;
                this.addToDownloads(img);
            }          
            return;
        }
        
        if( this.selected && img.id == this.selected.id ) {
            this.selected = null;    
            return;
        }
        this.selected = img;
        this.gettySearch = false;
        if( !inDownloads ) {
            this.addToDownloads(img);
        }
    }
    inDownloads(img) {
        const found = this.downloads.filter(item => item.id == img.id) || [];
        if( found.length > 0 ) {
            return true;
        }
        return false;
    }
    hasSize(img, size) {
        if( img.hasOwnProperty('sizes') && img.sizes.hasOwnProperty(size) ) {
            return true;
        }
        return false;
    }
    setProtocol(url) {
        return url.replace(/^http:|^https:/, window.location.protocol);
    }
    addToZip(url, last) {
        let image = new Image();
        let format = url.substring(url.lastIndexOf('.') + 1).toLowerCase();
        format = format == 'jpg' ? 'jpeg' : format;
        const mimeType = 'image/' + format;
        let filename = url.substring(url.lastIndexOf('/') + 1);
        filename = filename.substring(0, filename.indexOf('?'));
        image.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = image.naturalWidth;
            canvas.height = image.naturalHeight;
            canvas.getContext('2d').drawImage(image, 0, 0);
            const data = canvas.toDataURL(mimeType).replace(/^data:image\/(png|jpg|jpeg|gif|svg);base64,/, '');
            this.zip.file(filename, data, {base64: true});
            if( last ) {
                this.zip.generateAsync({type: 'blob'})
                    .then((blob) => {
                        saveAs(blob, 'bumblebee.zip');
                        this.downloads = [];
                    });
            }
        }
        image.crossOrigin = 'anonymous';
        image.src = this.setProtocol(url);
    }
    downloadAll() {
        this.zip = new JSZip();
        const downloads = this.downloads;
        const lastIndex = downloads.length - 1;
        for(var i = 0; i < downloads.length; i++) {
            const image = downloads[i];
            const url = image.sizes.ad.urlWithParams;
            const last = i == lastIndex;
            this.addToZip(url, last);
        }
    }
    toggleGettySearch(on) {
        this.gettySearch = on || !this.gettySearch;
        if( this.gettySearch && this.selected) {
            this.removeFromDownloads(this.selected);
            this.selected = null;
        }
    }
    allDownloadsHaveAdSize() {
        const downloads = this.downloads;
        for(var i = 0; i < downloads.length; i++) {
            const download = downloads[i];
            if( !this.hasSize(download, 'ad') ) {
                return false;
            }
        }
        return true;
    }
    getDownloadSize(img) {
        let size = img.width + 'x' + img.height;
        if( img.hasOwnProperty('sizes') && img.sizes.hasOwnProperty('ad') ) {
            size = img.sizes.ad.width + 'x' + img.sizes.ad.height;
        }
        return size;
    }
    getThumb(img) {
        let url = img.url;
        if( img.sizes && img.sizes.thumbnail ) {
            url = img.sizes.thumbnail.url;
        }
        return url;
    }
    deleteImage(img) {
        const sub = this.imagesService.imageDeleted.subscribe(did => {
            if( did ) {
                this.removeFromDownloads(img);
                if(this.selected.id == img.id) {
                    this.selected = null;
                }
            }
            sub.unsubscribe();
        });
        this.imagesService.deleteImage(this.slideshow.slides, this.slideshow.assignment, img);
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/slideshow/tabs/images.component.ts